/**
 * User Context Plugin for Admin Contextual Panel
 *
 * Handles profile pages: /profiles/:slug, /pr/:slug, /media/:slug
 */

import React from "react";
import { registerContext } from "../contextRegistry";
import MergeButton from "../MergeButton";

function UserContextPanel({ contextProps }) {
  const { slug } = contextProps;
  return (
    <div>
      <p className="small text-muted mb-2">Viewing profile: {slug}</p>
      <div className="d-grid gap-2">
        <a href={`/admin/users/${slug}`} className="btn btn-sm btn-garish">
          <i className="fa fa-user me-2" />
          Admin View
        </a>
        <a href={`/admin/users/${slug}/impersonate`} className="btn btn-sm btn-outline-garish">
          <i className="fa fa-user-secret me-2" />
          Impersonate
        </a>
        <a href={`/admin/users/${slug}/notifications`} className="btn btn-sm btn-outline-garish">
          <i className="fa fa-bell me-2" />
          Notifications
        </a>
        {/* Only a self-expert's /profiles/:slug page carries a mergeable entity
            (see Frontend::UserProfilesController#show); MergeButton renders nothing
            for a plain reporter/PR profile. */}
        <MergeButton />
      </div>
    </div>
  );
}

// Register this context
registerContext({
  name: "user",
  priority: 10,
  patterns: [
    {
      // Matches /profiles/:slug, /pr/:slug, /media/:slug
      pattern: /\/(profiles|pr|media)\/([^/?]+)/,
      extract: (match) => ({ slug: match[2] }),
    },
  ],
  component: UserContextPanel,
});

export default UserContextPanel;
